import type { DrawingTool } from '@ooh/ui/components/map-view';
import type { AreaSelectionActions } from '../use-area-selection';

export type ToolSubMode = 'add' | 'remove' | 'fresh';

/** Returns true when the tool is the click-select tool (point-add or point-remove). */
export function isClickSelectTool(tool: DrawingTool): boolean {
  return tool === 'point-add' || tool === 'point-remove';
}

/**
 * Returns the sub-mode suffix of a DrawingTool value.
 * 'lasso-remove' -> 'remove', 'rectangle-fresh' -> 'fresh', 'lasso-add' -> 'add', 'pan' -> 'add'
 */
export function getToolSubMode(tool: DrawingTool): ToolSubMode {
  if (tool.endsWith('remove')) return 'remove';
  if (tool.endsWith('fresh')) return 'fresh';
  return 'add';
}

/**
 * Dispatches matched pin ids to the correct selection action based on the tool's sub-mode.
 * Used by both the catalog map and the offer map overlay to avoid duplicating the
 * remove/fresh/add dispatch logic.
 */
export function dispatchAreaSelection(
  matchedIds: ReadonlyArray<string | number>,
  toolUsed: DrawingTool,
  actions: AreaSelectionActions,
): void {
  const subMode = getToolSubMode(toolUsed);
  if (subMode === 'remove') {
    actions.removeMany(matchedIds);
  } else if (subMode === 'fresh') {
    actions.replace(matchedIds);
  } else {
    actions.addMany(matchedIds);
  }
}
